import { setRegisteredData } from "./forms/registered-data";

$('[name="personal_data[billType]"]').on('change', function() {
    $('[name="personal_data[billPos]"]', this.form.elements).closest('.form-group').prop('disabled', $(this).val() != 'Paragon');
}).trigger('change');

$('[name="personal_data[emailRepeat]"]').each(function() {
    let $email = $('[name="personal_data[email]"]', this.form.elements);
    let $emailRepeat = $('[name="personal_data[emailRepeat]"]', this.form.elements);
    $($email).add($emailRepeat).on('input', function() {
        $emailRepeat.toggleValid($email.val() == $emailRepeat.val());
    }).trigger('change');
});

$('.application-form').on('submit-success', function(event, data) {
    $('.page').addClass('d-none');
    $('.page-game').removeClass('d-none');
    $('.result').addClass('d-none');

    $(`.result-${data.prize ? 'success' : 'failed'}`).removeClass('d-none');
    if (data.prize) {
        $('.result-prize-name').html(data.prize.name);
        $('.result-form-link').attr('href', data.formUrl);
    }
    setRegisteredData(data, 'section#application');
});

$('.game-run').on('click', function() {
    // page swap
    $('.page').addClass('d-none');
    $('.page-result').removeClass('d-none');
    $('.page-result').css('display', 'block');

    // modal (uncomment if you need modal instead of page swap)
    //$('#modal-form-application').modal('show');
});

$('.result-try-again').on('click', function() {
    $('.page').addClass('d-none');
    $('.page-form').removeClass('d-none');
});

$('[name="personal_data[noPesel]"]').on('change', function() {
    $('[name="personal_data[pesel]"]', this.form.elements).prop('disabled', $(this).prop('checked'));
    let fields = [
        '[name="personal_data[street]"]',
        '[name="personal_data[streetNr]"]',
        '[name="personal_data[flatNr]"]',
        '[name="personal_data[zipCode]"]',
        '[name="personal_data[city]"]',
    ];
    $(fields.join(', '), this.form.elements).closest('.form-group').prop('disabled', !$(this).prop('checked'));
}).trigger('change');

$('.winner-form').on('submit-success', function(event, data) {
    setRegisteredData(data, 'section#winner');

    // page swap
    $('.page').addClass('d-none');
    $('.page-thank-you').removeClass('d-none');
    $('.page-thank-you').css('display', 'block');

    // modal (uncomment if you need modal instead of page swap)
    //$('#modal-form-winner').modal('show');
});

function scrollToThanks() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

$('#form-child').on('submit-success', function(event, data) {
    // page swap
    // $('.page').addClass('d-none');
    // $('.page-thank-you').removeClass('d-none');
    // $('.page-thank-you').css('display', 'flex');

    // modal (uncomment if you need modal instead of page swap)
    // $('#modal-form-child').modal('show');

    $('.row').addClass('justify-content-center');
    $('.form-container').remove();
    $('.thanks-container').removeClass('d-none');
    $('.bananas').removeClass('d-none');
    $('.decor-left').addClass('d-none');
    scrollToThanks();
});

$('#form-parent').on('submit-success', function(event, data) {
    // page swap
    // $('.page').addClass('d-none');
    // $('.page-thank-you').removeClass('d-none');
    // $('.page-thank-you').css('display', 'flex');

    // modal (uncomment if you need modal instead of page swap)
    // $('#modal-form-parent').modal('show');

    $('.row').addClass('justify-content-center');
    $('.form-container').remove();
    $('.thanks-container').removeClass('d-none');
    $('.bananas').removeClass('d-none');
    $('.decor-left').addClass('d-none');
    scrollToThanks();
});

$('#form-question').on('submit-success', function(event, data) {
    // page swap
    // $('.page').addClass('d-none');
    // $('.page-thank-you').removeClass('d-none');
    // $('.page-thank-you').css('display', 'flex');

    // modal (uncomment if you need modal instead of page swap)
    // $('#modal-form-question').modal('show');

    $('.row').addClass('justify-content-center');
    $('.form-container').remove();
    $('.thanks-container').removeClass('d-none');
    $('.bananas').removeClass('d-none');
    $('.decor-left').addClass('d-none');
    $('#question_form_milks').remove();
    scrollToThanks();
});

$('.contact-form').on('submit-success', function(event, data) {
    setRegisteredData(data, 'section#contact');

    // page swap
    // $('.page').addClass('d-none');
    $('.page-thank-you').removeClass('d-none');
    $('.page-thank-you').css('display', 'flex');

    $('#modal-form-contact .page-thank-you').find('.mail-address').text(data.email);
    $('#modal-form-contact .page-thank-you').find('.mail-content').text(data.content);

    // modal (uncomment if you need modal instead of page swap)
    $('#modal-form-contact').modal('show');
});
